// app/frontend/components/Layout.tsx

import React, { useEffect, useState, ReactNode } from 'react';
import Navbar from './Navbar/Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';
import FloatingHelpMenu from './FloatingHelpMenu';
import { MantineProvider } from '@mantine/core';
import { UserProvider } from '../src/context/UserContext';

// Define layout props interface
interface LayoutProps {
  children?: ReactNode;
  hideNavbar?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, hideNavbar = false }) => {
  const [isSidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const isLoginPage = window.location.pathname === '/login';

  // Add debugging logs
  // console.log('🔍 Layout rendering with props:', {
  //   hideNavbar,
  //   pathname: window.location.pathname,
  //   hasChildren: !!children,
  // });

  // Skip rendering navbar and sidebar if hideNavbar is true
  if (hideNavbar) {
    // console.log('🔍 Using simplified layout without navbar!');
    return (
      <UserProvider>
        <div className="app-container" style={{ border: '3px solid red', padding: '10px' }}>
          <div style={{ background: '#ffeeee', padding: '10px', marginBottom: '0px' }}>Layout with hideNavbar=true</div>
          <main className="main-content">{children}</main>
          <Footer />
          <FloatingHelpMenu />
        </div>
      </UserProvider>
    );
  }

  // console.log('🔍 Using full layout with navbar and sidebar');

  useEffect(() => {
    const handleClick = (e: Event) => {
      e.preventDefault();
      setSidebarOpen(true);
    };

    let menuToggler = document.getElementById('menu-toggler-new');

    if (menuToggler) {
      menuToggler.addEventListener('click', handleClick);
    }

    const observer = new MutationObserver(() => {
      const updatedMenuToggler = document.getElementById('menu-toggler-new');
      if (updatedMenuToggler && updatedMenuToggler !== menuToggler) {
        updatedMenuToggler.addEventListener('click', handleClick);
        menuToggler = updatedMenuToggler;
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      menuToggler?.removeEventListener('click', handleClick);
      observer.disconnect();
    };
  }, []);

  return (
    <MantineProvider>
      <UserProvider>
        <div className="app-container">
          <Navbar toggleSidebar={() => setSidebarOpen((prev) => !prev)} isLoginPage={isLoginPage} />
          <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setSidebarOpen(false)} />
          <main className="main-content">{children}</main>
          <Footer />
          <FloatingHelpMenu />
        </div>
      </UserProvider>
    </MantineProvider>
  );
};

export default Layout;
